"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _fetcher = _interopRequireDefault(require("./fetcher"));
var _LanguageProvider = require("../../common/LanguageProvider");
var _cache = require("@deosite/helpers/cache");
var _react = require("react");
var _addSortFilters = _interopRequireDefault(require("../../common/addSortFilters"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _filters = require("@deosite/helpers/filters");
var _removeAdditionalParameterFromFiltersPickedFromUrl = require("@deosite/helpers/removeAdditionalParameterFromFiltersPickedFromUrl");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  searchPath: "/catalogsearch/result/"
};
var useSearchNew = function useSearchNew(_ref) {
  var initialData = _ref.initialData,
    cacheSSR = _ref.cacheSSR,
    router = _ref.router,
    _ref$searchPath = _ref.searchPath,
    searchPath = _ref$searchPath === void 0 ? defaultProps.searchPath : _ref$searchPath;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var translations = {
    recommended: (0, _langLibrary["default"])("recommended"),
    priceCatalogHigh: (0, _langLibrary["default"])("price catalog low to high"),
    priceCatalogLow: (0, _langLibrary["default"])("price catalog high to low"),
    finalPriceHigh: (0, _langLibrary["default"])("price low to high"),
    finalPriceLow: (0, _langLibrary["default"])("price high to low"),
    sortByNameDesc: (0, _langLibrary["default"])("sortByNameDesc"),
    sortByNameAsc: (0, _langLibrary["default"])("sortByNameAsc")
  };
  var _useState = (0, _react.useState)({
      pickedFiltersKeys: initialData.filters.filter(function (filter) {
        return filter.value;
      }).map(function (filter) {
        return filter.id;
      }),
      initialFilters: initialData.defaultFilters
    }),
    filtersState = _useState[0],
    setFiltersState = _useState[1];
  var fetchedDataCache = (0, _cache.getResultFromCache)((0, _removeAdditionalParameterFromFiltersPickedFromUrl.removeAdditionalParameterFromFiltersString)(decodeURIComponent(router.asPath)), cacheSSR);
  var data = fetchedDataCache;
  var changeSearchPagination = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(filtersValue) {
      var page,
        empty,
        query,
        filterString,
        url,
        responseFromCache,
        _filtersReduce,
        pickedFilters,
        response,
        _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
              empty = _args.length > 2 ? _args[2] : undefined;
              query = _args.length > 3 ? _args[3] : undefined;
              filterString = "";
              filtersValue.forEach(function (filter) {
                if (filter.committedValue) {
                  if (filter.id === "sort" && filter.value) {
                    var _filter$value$value$s = filter.value.value.split("-"),
                      _filter$value$value$s2 = (0, _slicedToArray2["default"])(_filter$value$value$s, 2),
                      name = _filter$value$value$s2[0],
                      direction = _filter$value$value$s2[1];
                    filterString += "dir=".concat(direction, "&order=").concat(name, "&");
                  } else if (filter.type === "range") {
                    var _filter$value;
                    filterString += ((_filter$value = filter.value) === null || _filter$value === void 0 ? void 0 : _filter$value.from) !== undefined ? "".concat(filter.id, "=").concat(filter.value.from, "-").concat(filter.value.to, "&") : "";
                  } else {
                    if (!filter.value) return;
                    filterString += "".concat(filter.id, "=").concat(filter.value.map(function (val) {
                      return val.id;
                    }).join(","), "&");
                  }
                }
              });
              filterString = filterString.substring(0, filterString.length - 1);
              if (filterString) {
                filterString = "".concat(filterString);
              }
              filterString = filterString ? "?".concat(filterString) : "";
              url = "".concat(searchPath + query).concat(filterString).concat(filterString ? "&p=1" : "?p=1");
              url = url.replace(/p=[0-9]*/, "p=".concat(page));
              responseFromCache = (0, _cache.getResultFromCache)(url.replace(/p=[0-9]*/, "p=".concat(page)), cacheSSR);
              _filtersReduce = (0, _filters.filtersReduce)(filtersValue, filtersState.pickedFiltersKeys), pickedFilters = _filtersReduce.pickedFilters;
              if (!(responseFromCache !== null && responseFromCache !== void 0)) {
                _context.next = 16;
                break;
              }
              _context.t0 = responseFromCache;
              _context.next = 19;
              break;
            case 16:
              _context.next = 18;
              return (0, _fetcher["default"])({
                phrase: query,
                language: language,
                pickedFilters: pickedFilters,
                currentPage: page,
                pageSize: global.__appConfig__.categoryPageSizeLargerRange,
                initialFilters: filtersState.initialFilters
              });
            case 18:
              _context.t0 = _context.sent;
            case 19:
              response = _context.t0;
              if (!responseFromCache) {
                (0, _cache.setUrlInCache)(url, response, cacheSSR);
              }
              return _context.abrupt("return", url);
            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function changeSearchPagination(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  (0, _addSortFilters["default"])(data.filters, translations, false, true);
  return _objectSpread(_objectSpread({}, data), {}, {
    changeSearchPagination: changeSearchPagination
  });
};
var _default = useSearchNew;
exports["default"] = _default;